import {
  Alert,
  Box,
  Button,
  Divider,
  Grid,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import { IAbacUser } from "../../../../App/Typings/AbacUser";
import AdminAttributeAssignmentComponent from "./AdminAttributeAssignmentComponent";
import useUserDetailsState from "../../../ABAC/ManageUserPage/State/UserDetailsState";

interface IUserDetailsProps {
  currentUser: IAbacUser;
  menuAnchorElement: any;
  isMenuOpen: boolean;
  handleMenuClose: any;
}

export default function AdminUserDetailsForm({
  currentUser,
  menuAnchorElement,
  isMenuOpen,
  handleMenuClose,
}: IUserDetailsProps) {
  const {
    getters: { isActive, formik },
    setters: { setIsActive },
    handlers: { handleResetPassword },
  } = useUserDetailsState(currentUser);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        {!isActive && (
          <Alert sx={{ mb: { xs: "8%", sm: "1%" } }} severity="error">
            This User is currently deactivated. They will not have access to any
            NAS Applications until they are activated.
          </Alert>
        )}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              sx={{ mt: "2%" }}
              name="firstName"
              label="First Name"
              placeholder="Enter First Name"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.firstName)}
              helperText={
                formik.errors.firstName ||
                `${formik.values.firstName.trim().length}/50`
              }
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              sx={{ mt: "2%" }}
              name="lastName"
              label="Last Name"
              placeholder="Enter Last Name"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.lastName)}
              helperText={
                formik.errors.lastName ||
                `${formik.values.lastName.trim().length}/50`
              }
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              sx={{ mt: "2%" }}
              name="emailAddress"
              label="Email Address"
              placeholder="Enter Email Address"
              value={formik.values.emailAddress}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.emailAddress)}
              helperText={
                formik.errors.emailAddress ||
                `${formik.values.emailAddress.trim().length}/50`
              }
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              sx={{ mt: "2%" }}
              name="phoneNumber"
              label="Phone Number"
              placeholder="Enter Phone Number"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.phoneNumber)}
              helperText={
                formik.errors.phoneNumber ||
                `${formik.values.phoneNumber.trim().length}/50`
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Divider />
            <Box sx={{ mt: "2%", mb: "5vh" }}>
              <h3>Client Permissions:</h3>
              <AdminAttributeAssignmentComponent />
            </Box>
          </Grid>
        </Grid>
        <Grid
          container
          item
          justifyContent="flex-end"
          xs={12}
          sx={{ mt: "5%" }}
        >
          <Button
            sx={{ width: { xs: "100%", sm: "25%" } }}
            variant="contained"
            type="submit"
            disabled={!formik.isValid}
          >
            Save Changes
          </Button>
        </Grid>
      </form>
      <Menu
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 125,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        anchorEl={menuAnchorElement}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem
          onClick={() => {
            handleResetPassword();
            handleMenuClose();
          }}
        >
          Reset Password
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsActive(!isActive);
            handleMenuClose();
          }}
        >
          {isActive ? "Deactivate User" : "Activate User"}
        </MenuItem>
        <MenuItem disabled={true}>Delete User</MenuItem>
      </Menu>
    </>
  );
}
